import * as Types from '@x/schemas/ecommerce';

import { gql } from 'apollo-angular';
export type ShopMetaFragment = { __typename: 'ShopMetaContentObject', description?: string | null | undefined, title?: string | null | undefined, keywords?: string | null | undefined };

export const ShopMetaFragmentDoc = gql`
    fragment ShopMeta on ShopMetaContentObject {
  description
  title
  keywords
}
    `;